import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBGlobalImport } from '../../types/import';
import { EndpointResponse } from '../../types/endpoints';
import type { ApiQueryParams } from '../../types/apiQuery';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

type RequestParams = Pick<ApiQueryParams, 'limit' | 'page'>;

type Response = DBGlobalImport[];

/** Global cross-model imports feed (all import types in one flat, newest-first list). */
export const getAllImports = async (
  scope: RequestScope,
  { limit = 1000, page = 1 }: RequestParams = {},
  requestOptions: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    const result = await scopedApi(scope).get<EndpointResponse<Response>>(`imports?sort=created_at:-1&limit=${limit}&page=${page}`, requestOptions);

    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
